import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from '@fullcalendar/timegrid';

import { Col, Container, Row } from 'react-bootstrap';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';

import EmployeeLeavesShimmer from './EmployeeLeavesShimmer';
import LeaveModal from "./LeaveModal";

import './index.css';

const EmployeeLeaves = () => {
    const [showModal, setShowModal] = useState(false);
    const [employeeOnLeavesDate, setEmplyeeOnLeaveDate] = useState('');
    let previousMonth = (new Date().getMonth() + 1) > 9 ? new Date().getMonth() : 0 + "" + (new Date().getMonth());
    let nextMonth = (new Date().getMonth() + 1) > 9 ? new Date().getMonth() + 2 : 0 + "" + (new Date().getMonth() + 2);
    const calendarRef = useRef();
    const [leaves, setLeaves] = useState([{ holiday: "2024-08-19", eventName: "Rakhi" }, { holiday: "2024-08-21", eventName: "Optional" }]);
    const [eventList, setEventList] = useState([
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Anirudh Sharma",
                empImage: "images.png",
                leaveType: "full",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Anirudh Sharma",
                empImage: "images.png",
                leaveType: "full",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Anshul Verma",
                empImage: "images.png",
                leaveType: "full",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },  
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Anshul Verma",
                empImage: "images.png",
                leaveType: "full",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },  
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Anshul Verma",
                empImage: "images.png",
                leaveType: "full",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },  
        
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Krishna Vaishnav",
                empImage: "images.png",
                leaveType: "full",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Gracy Bhartia",
                empImage: "images.png",
                leaveType: "full",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },                
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Karan Sen",
                empImage: "images.png",
                leaveType: "full",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Sunil Sharma",
                empImage: "images.png",
                leaveType: "full",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Kartik Shirvastav",
                empImage: "images.png",
                leaveType: "full",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Abhinav Jha",
                empImage: "images.png",
                leaveType: "full",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Kunal Vaishnav",
                empImage: "images.png",
                leaveType: "half",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Anirudh",
                empImage: "anirudh.jpg",
                leaveType: "half",
                leaveDate: "2024-08-13"
            }), date: "2024-08-13"
        },
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Kunal Vaishnav",
                empImage: "images.png",
                leaveType: "half",
                leaveDate: "2024-08-15"
            }), date: "2024-08-15"
        },
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Anirudh",
                empImage: "anirudh.jpg",
                leaveType: "full",
                leaveDate: "2024-08-13"
            }), date: "2024-08-13"
        },
        {
            title: JSON.stringify({
                isWeekend: false,
                isHoliDay: false,
                employeeName: "Anirudh",
                empImage: "anirudh.jpg",
                leaveType: "half",
                leaveDate: "2024-08-13"
            }), date: "2024-08-13"
        }
    ]);


    const setTitle = () => {
        document.querySelector('.fc-daygrid-day.fc-day-today').title = "Today";
        document.querySelector('.fc-Optionalleaves-button').title = "Optional Leave";
        document.querySelector('.fc-Comonleaves-button').title = "Common Leave";
        document.querySelector('.fc-CurrentDay-button').title = "Current Day";
        document.querySelector('.fc-WeekEnd-button').title = "Weekend";
    }

    const getMyCustomDetails = async () => {
        setTitle();
        let parentContainer = document.querySelectorAll('.fc-daygrid-day-events');
        for (let i of parentContainer) {
            if (i?.children.length >= 2) {
                let node = document.createElement('div');
                node.setAttribute('value', i.parentElement.parentElement.getAttribute('data-date'))
                node.innerHTML = `<i class="fa-solid fa-caret-down fs-4"></i>`
                node.addEventListener('click', () => {
                    setShowModal(!showModal);
                    setEmplyeeOnLeaveDate(node.getAttribute('value'));
                })
                node.setAttribute('class', "custom");
                i.parentElement.prepend(node);
            }

            // Leaves iterator for holidays
            leaves.map(item => {
                if (item.holiday === i.parentElement.parentElement.getAttribute('data-date')) {
                    i.parentElement.parentElement.setAttribute('title', item.eventName)
                    if (item.eventName.toLowerCase() === 'optional') {
                        i.parentElement.style = "background : #fafbd9;";
                        i.classList.add('badge', 'text-bg-warning');
                    } else {
                        i.parentElement.style = "background : #e1f0fe;";
                        i.classList.add('badge', 'text-bg-info');
                    }
                    i.innerHTML = item.eventName;
                }
            })
        }
    }

    useEffect(() => {
        getMyCustomDetails();
    }, []);

    return (
        <>
            {/* Employee Leaves Heading Section */}
            <Container className='mt-5'>
                <Row className='justify-content-center d-flex'>
                    <Col lg={10} xs={12} sm={12}>
                        <div className="p-2 text-center" style={{ height: "40px", backgroundColor: "#ffffff", borderRadius: "5px", }}>
                            <span className='fw-semibold' style={{ color: "#605C68", fontSize: "large" }}>Employee Leaves</span>
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* Main Section for the Employee Leave Collection */}
            {
                eventList !== undefined ?
                    <Container className='mt-4'>
                        <Row className="d-flex justify-content-center">                            
                            <Col lg={10}>
                                <FullCalendar
                                    height="85vh"
                                    plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin]}
                                    initialView="dayGridMonth"
                                    ref={calendarRef}
                                    headerToolbar={{
                                        left: 'title',
                                        center: "WeekEnd CurrentDay TodayButton Comonleaves Optionalleaves",
                                        right: 'PrevButton NewButton',
                                    }}
                                    customButtons={{
                                        PrevButton: {
                                            text: '< Previous',
                                            click: function (e) {
                                                calendarRef.current.calendar.prev();
                                                getMyCustomDetails();
                                            }
                                        },
                                        NewButton: {
                                            text: 'Next >',
                                            click: () => {
                                                calendarRef.current.calendar.next();
                                                getMyCustomDetails();
                                            }
                                        },
                                        TodayButton: {
                                            text: 'Today',
                                            click: () => {
                                                calendarRef.current.calendar.today();
                                                getMyCustomDetails();
                                            }
                                        },
                                        WeekEnd: {
                                            text: "1"                                            
                                        },
                                        CurrentDay: {
                                            text: "2"                                            
                                        },
                                        Comonleaves: {
                                            text: "3"                                            
                                        },
                                        Optionalleaves : {
                                            text: "4"                                            
                                        }
                                    }}
                                    validRange={
                                        {
                                            start: `2024-${previousMonth}-01`,
                                            end: `2024-${nextMonth}-31`
                                        }
                                    }
                                    events={eventList}
                                    // eventClick={event => {
                                    //     console.log(event.event);
                                    // }}
                                    selectable={true}
                                    editable
                                    duration='3'
                                    eventContent={renderEventContent}
                                    showNonCurrentDates={false}
                                />
                            </Col>
                        </Row>
                    </Container>
                    : <EmployeeLeavesShimmer />
            }
            {employeeOnLeavesDate.length != 0 && <LeaveModal showModal={showModal} setShowModal={setShowModal} employeeOnLeave={eventList} employeeOnLeavesDate={employeeOnLeavesDate} />}
        </>
    )
}

const renderEventContent = (eventInfo) => {
    let userDetails = JSON.parse(eventInfo.event.title)
    return (
        <>
            <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Popover className="p-2">{userDetails.employeeName}</Popover>} >
                <div data-bs-toggle="tooltip" data-bs-html="true" className='userbadge' data-bs-title="Anirudh" style={{ border: userDetails.leaveType == 'full' ? "3px solid red" : "3px solid blue", backgroundImage: `url(${userDetails.empImage})` }}></div>
            </OverlayTrigger>
        </>
    );
}

export default EmployeeLeaves;